import React from 'react';
import { motion } from 'framer-motion';
import { X, CheckCircle } from 'lucide-react';
export function ObjectionsSection() {
  const failures = ['Cuadros de tareas que nadie mira', 'Premios que terminan siendo sobornos', 'Amenazas que solo empeoran el vínculo', 'Tips de redes que funcionan 2 días', 'Aplicaciones que complican más'];
  return <section className="py-20 bg-stone-50" data-id="element-109">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
        <div className="text-center mb-12" data-id="element-111">
          <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900 mb-4" data-id="element-112">
            «¿Y si ya probé de todo?»
          </h2>
          <p className="text-xl text-stone-600" data-id="element-113">Perfecto. Hablemos de eso.</p>
        </div>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-114">
          <ul className="space-y-4" data-id="element-115">
            {failures.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-center gap-4 text-stone-400 line-through decoration-stone-400" data-id="element-116">
                <X className="w-5 h-5 text-red-400 shrink-0" data-id="element-117" />
                <span className="text-lg" data-id="element-118">{item}</span>
              </motion.li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-amber-50 border-l-8 border-amber-500 rounded-2xl p-8 md:p-10 max-w-3xl mx-auto shadow-sm" data-id="element-119">
          <p className="text-lg text-stone-700 mb-4" data-id="element-120">
            No es porque tú no puedas. Es porque te dieron piezas sueltas, no un
            sistema.
          </p>
          <p className="text-2xl font-bold text-stone-900 mb-6" data-id="element-121">
            Un hogar no se ordena con parches. Se ordena con diseño.
          </p>
          <div className="flex items-start gap-3" data-id="element-122">
            <CheckCircle className="w-6 h-6 text-emerald-500 shrink-0 mt-1" data-id="element-123" />
            <p className="text-stone-700 font-medium italic" data-id="element-124">
              Estás usando palabras donde tu hijo necesita imágenes. Cuando
              entiendes eso... dejas de pelear contra tu hijo. Y empiezas a
              guiarlo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}